<template>
    <section id="navHorizontale">
        <div class="container-page">
            <div class="box-input">
                <div class="position-relative d-flex align-items-center w-50">
                    <input type="text" class="w-100 form-control input-num-client" v-model="inputOemSearch" @keydown.enter="searchByOEM" placeholder="OEM / Référence..." aria-label="Rechercher" aria-describedby="basic-addon2">
                    <i class="fas fa-search search-icon searchOem position-absolute" @click="searchByOEM"></i>
                </div>
                <input type="text" class="form-control input-num-client" placeholder="Saisir le numéro client"
                    aria-label="Rechercher" aria-describedby="basic-addon2">
                <button class="btn btn-search" type="button">
                    <i class="fas fa-search search-icon"></i>
                </button>
            </div>
            <div class="box-icon">
                <BoxCartButton class="btnCart" link="/panier"/>
                <a href="/">
                    <svg width="25" height="25" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9 0C8.28877 0 7.71416 0.558594 7.71416 1.25V1.94922C4.80092 2.39844 2.57079 4.85156 2.57079 7.8125V9.11719C2.57079 10.8906 1.94796 12.6133 0.81079 13.9961L0.212069 14.7266C-0.0209898 15.0078 -0.0651907 15.3945 0.0955397 15.7188C0.25627 16.043 0.593804 16.25 0.963483 16.25H17.0365C17.4062 16.25 17.7437 16.043 17.9045 15.7188C18.0652 15.3945 18.021 15.0078 17.7879 14.7266L17.1892 14C16.052 12.6133 15.4292 10.8906 15.4292 9.11719V7.8125C15.4292 4.85156 13.1991 2.39844 10.2858 1.94922V1.25C10.2858 0.558594 9.71123 0 9 0ZM9 3.75H9.32146C11.6279 3.75 13.5004 5.57031 13.5004 7.8125V9.11719C13.5004 10.9883 14.059 12.8125 15.0957 14.375H2.9043C3.94101 12.8125 4.49955 10.9883 4.49955 9.11719V7.8125C4.49955 5.57031 6.37206 3.75 8.67854 3.75H9ZM11.5717 17.5H9H6.42832C6.42832 18.1641 6.69754 18.8008 7.17973 19.2695C7.66192 19.7383 8.3169 20 9 20C9.6831 20 10.3381 19.7383 10.8203 19.2695C11.3025 18.8008 11.5717 18.1641 11.5717 17.5Z"
                            fill="#3B393D" />
                    </svg>
                </a>
                <NuxtLink to="/my-account/info-user"><i class="regular-user">
                        <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9 13.0005C7.67392 13.0005 6.40215 13.5273 5.46447 14.465C4.52678 15.4026 4 16.6744 4 18.0005V19.0005C4 19.0005 6 21.0005 12 21.0005C18 21.0005 20 19.0005 20 19.0005V18.0005C20 16.6744 19.4732 15.4026 18.5355 14.465C17.5979 13.5273 16.3261 13.0005 15 13.0005H9Z"
                                stroke="#3B393D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M12 13.0005C14.7614 13.0005 17 10.7619 17 8.00049C17 5.23906 14.7614 3.00049 12 3.00049C9.23858 3.00049 7 5.23906 7 8.00049C7 10.7619 9.23858 13.0005 12 13.0005Z"
                                stroke="#3B393D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </i></NuxtLink>
                <a href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                    <i>
                        <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18.1095 13.4955V10.5045L19.77 8.84401C19.4479 8.01789 19.0012 7.24595 18.4455 6.55501L16.1805 7.16251L13.59 5.66701L12.9825 3.39901C12.1061 3.26553 11.2144 3.26553 10.338 3.39901L9.7305 5.66701L7.14 7.16251L4.875 6.55501C4.32 7.24501 3.8715 8.01751 3.549 8.84401L5.2095 10.5045V13.4955L3.549 15.156C3.8715 15.9825 4.3185 16.7535 4.875 17.445L7.14 16.8375L9.7305 18.333L10.338 20.601C11.2144 20.7345 12.1061 20.7345 12.9825 20.601L13.59 18.333L16.1805 16.8375L18.4455 17.445C19.0005 16.755 19.449 15.9825 19.77 15.156L18.1095 13.4955ZM19.041 19.4685L16.434 18.7695L15.135 19.5195L14.436 22.1295C13.551 22.3695 12.621 22.5 11.661 22.5C10.6995 22.5 9.768 22.371 8.8845 22.1295L8.184 19.5195L6.885 18.7695L4.2795 19.4685C2.93771 18.1444 1.97754 16.4831 1.5 14.6595L3.4095 12.75V11.25L1.5 9.34051C1.97729 7.51634 2.93747 5.85454 4.2795 4.53001L6.885 5.22901L8.184 4.47901L8.8845 1.86901C9.78891 1.62284 10.7222 1.49874 11.6595 1.50001C12.621 1.50001 13.5525 1.62901 14.436 1.87051L15.135 4.48051L16.434 5.23051L19.041 4.53151C20.361 5.83651 21.336 7.48801 21.8205 9.34051L19.9095 11.25V12.75L21.8205 14.6595C21.343 16.4831 20.3828 18.1444 19.041 19.4685ZM11.661 14.7C12.0156 14.7 12.3667 14.6302 12.6942 14.4945C13.0218 14.3588 13.3195 14.1599 13.5702 13.9092C13.8209 13.6585 14.0198 13.3608 14.1555 13.0333C14.2912 12.7057 14.361 12.3546 14.361 12C14.361 11.6454 14.2912 11.2943 14.1555 10.9668C14.0198 10.6392 13.8209 10.3415 13.5702 10.0908C13.3195 9.8401 13.0218 9.64122 12.6942 9.50554C12.3667 9.36985 12.0156 9.30001 11.661 9.30001C10.9449 9.30001 10.2582 9.58447 9.75181 10.0908C9.24546 10.5972 8.961 11.2839 8.961 12C8.961 12.7161 9.24546 13.4029 9.75181 13.9092C10.2582 14.4155 10.9449 14.7 11.661 14.7ZM11.661 16.5C10.4675 16.5 9.32293 16.0259 8.47902 15.182C7.63511 14.3381 7.161 13.1935 7.161 12C7.161 10.8065 7.63511 9.66194 8.47902 8.81803C9.32293 7.97412 10.4675 7.50001 11.661 7.50001C12.8545 7.50001 13.9991 7.97412 14.843 8.81803C15.6869 9.66194 16.161 10.8065 16.161 12C16.161 13.1935 15.6869 14.3381 14.843 15.182C13.9991 16.0259 12.8545 16.5 11.661 16.5Z"
                                fill="#3B393D" />
                        </svg>
                    </i>
                </a>
                <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                    <p class="gradient-text d-flex justify-content-between align-items-center column-gap-5">
                        <span>Mes paramètres</span>
                        <i class="fa-solid fa-xmark"></i>
                    </p>
                    <hr>
                    <a class="dropdown-item" href="#">Mon abonnement</a>
                    <a class="dropdown-item" href="#">Mes mécaniciens</a>
                    <a class="dropdown-item" href="#">Mes prestations</a>
                    <a class="dropdown-item" href="#">Mes taux horaires</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const inputOemSearch = ref()

const searchByOEM = () => {
    location.replace(`/catalogue/liste/liste-produits?numOem=${inputOemSearch.value}`)
}
</script>

<style lang="scss" scoped>
.container-page {
    padding: 0px;
    background-color: transparent;
    border-radius: 15px;
    /* margin: 1rem 4rem; */
    display: flex;
    gap: 1rem;
}

.box-input {
    background: white;
    width: 75%;
    padding: 15px 30px;
    border-radius: 10px;
    display: flex;
    gap: 1rem;
}

.form-control {
    width: 40%;
}

.box-icon {
    background: white;
    width: 25%;
    padding: 10px 30px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

}

.box-icon a svg {

    transition: 0.7s all;
}

.box-icon a:hover svg {
    transform: translateY(-5px);
}

.box-icon i span {
    font-size: 10px;
}

.box-icon i {
    transition: .7s all;
}

.box-icon i:hover {
    transform: translateY(-5px);
}

.box-icon .fa-user {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.box-icon .fa-user:after {
    content: "Mon compte";
    font-size: 13px;
    text-transform: lowercase;
}

.box-icon a {
    text-decoration: none;
    color: rgb(var(--mainText));
    font-size: 25px;
}

.dropdown-menu.show {
    transform: translate(-104px, 76px) !important;
    padding: 1.25rem 1.5rem;
}

.dropdown-item {
    font-family: Inter;
    font-size: 1rem !important;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem;
}

.gradient-text {
    /*font-weight: 600;*/
    color: var(--mainColor)
}

.regular-user::after {
    content: "Mon compte";
    font-size: 15px;
    font-weight: 500;
    margin-left: 5px;
    font-family: Inter;
    font-style: normal;
    line-height: 1.5rem;
    /* 150% */
    letter-spacing: -0.01rem;
}

input,
input::placeholder {
    font-family: Inter;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
    /* 150% */
    letter-spacing: -0.01rem;
    border-radius: 0.625rem;
}

input::placeholder {
    color: var(--neutral71);
    font-size: 14px;
}

.btn-search {
    border-radius: 0.625rem;
}

.btnCart:deep(.buttonCart__number) {
  font-size: .825rem;
  transform: translate(34%, 27%);
  background-color: var(--mainColor);
}

.search-icon {
  right: 10px;
  font-size: 16px;
}

.searchOem {
  cursor: pointer;
}

@media screen and (max-width: 1350px) {
    .box-input {
        width: 50%;
    }

    .box-icon {
        width: 50%;
    }

    .form-control {
        width: 70%;
    }

    .container-page {
        margin: 1rem 0rem;
    }
}

@media screen and (max-width: 1000px) {
    .box-input {
        width: 100%;
    }

    .box-icon {
        width: 100%;
    }
}

@media screen and (max-width: 992px) {
    .regular-user::after {
        display: none;
    }

    #navbar-horizontale .container-page {
        flex-direction: column;
    }

}
</style>

